import type { OriginalMeta } from "~/types/ip";
import { sameText as loc } from "@laftel-ip-originals/notion/locale";
import { assertOriginalsParity } from "@laftel-ip-originals/notion/originals";
const poster = (name: string) => `/images/ip/posters/${name}`;

export const ORIGINALS_LIST: OriginalMeta[] = [
  {
    slug: "super-secret",
    title: loc("슈퍼 시크릿"),
    description: loc(""),
    thumbnail: poster("슈퍼시크릿.jpg"),
    externalUrl: "https://laftel.net/item/39404",
  },
  {
    slug: "semantic-error",
    title: loc("시맨틱 에러"),
    description: loc(""),
    thumbnail: poster("시맨틱에러.jpg"),
    externalUrl: "https://laftel.net/item/40221",
  },
  {
    slug: "that-summer",
    title: loc("그 여름"),
    description: loc(""),
    thumbnail: poster("그여름.jpg"),
    externalUrl: "https://laftel.net/item/40366",
  },
  {
    slug: "hell-behind-the-door",
    title: loc("문 뒤에 지옥이 있다"),
    description: loc(""),
    thumbnail: poster("문 뒤에 지옥이 있다.jpg"),
    externalUrl: "https://laftel.net/item/40317",
  },
  {
    slug: "slow-rain",
    title: loc("느린 장마"),
    description: loc(""),
    thumbnail: poster("느린 장마.jpg"),
    externalUrl: "https://laftel.net/item/41181",
  },
  {
    slug: "magwi",
    title: loc("마귀"),
    description: loc(""),
    thumbnail: poster("마귀.jpg"),
    externalUrl: "https://laftel.net/item/41332",
  },
  {
    slug: "elena-avoy",
    title: loc("일레나 에보이 관찰일지"),
    description: loc(""),
    thumbnail: poster("일레나 에보이 관찰 일지.jpg"),
    externalUrl: "https://laftel.net/item/41336",
  },
  {
    slug: "demon-king",
    title: loc("마왕님은 죽고싶어"),
    description: loc(""),
    thumbnail: poster("마왕님은 죽고 싶어.jpg"),
    externalUrl: "https://laftel.net/item/41405",
  },
  {
    slug: "veranda",
    title: loc("우리 베란다에서 만나요"),
    description: loc(""),
    thumbnail: poster("우리 베란다에서 만나요.jpg"),
    externalUrl: "https://laftel.net/item/41323",
  },
  {
    slug: "no-more-prince",
    title: loc("노 모어 프린스"),
    description: loc(""),
    thumbnail: poster("노 모어 프린스.jpg"),
    externalUrl: "https://laftel.net/item/41321",
  },
  {
    slug: "forgotten-princess",
    title: loc("잊혀진 황녀는 평화롭게 살고싶어"),
    description: loc(""),
    thumbnail: poster("잊혀진 황녀는 평화롭게 살고 싶어.jpg"),
    externalUrl: "https://laftel.net/item/41448",
  },
  {
    slug: "clueless-party",
    title: loc("눈치 없는 돌쇠"),
    description: loc(""),
    thumbnail: poster("눈치 없는 돌쇠.jpg"),
    externalUrl: "https://laftel.net/item/41430",
  },
  {
    slug: "4-week-lover",
    title: loc("4주 애인"),
    description: loc(""),
    thumbnail: poster("4주 애인.jpg"),
    externalUrl: "https://laftel.net/item/41410",
  },
  {
    slug: "please-kill-me",
    title: loc("부탁이니 죽어주라"),
    description: loc(""),
    thumbnail: poster("부탁이니 죽어주라.jpg"),
    externalUrl: "https://laftel.net/item/41449",
  },
  {
    slug: "no-dating-zone",
    title: loc("연애제한구역"),
    description: loc(""),
    thumbnail: poster("연애제한구역.jpg"),
    externalUrl: "https://laftel.net/item/41563",
  },
  {
    slug: "terrarium-adventure",
    title: loc("테라리움 어드벤처"),
    description: loc(""),
    thumbnail: poster("테라리움 어드벤처.jpg"),
    externalUrl: "https://laftel.net/item/41447",
  },
  {
    slug: "tiger-comes",
    title: loc("호랑이 들어와요"),
    description: loc(""),
    thumbnail: poster("호랑이 들어와요.jpg"),
    externalUrl: "https://laftel.net/item/42320",
  },
  {
    slug: "homeless",
    title: loc("집이 없어"),
    description: loc(""),
    thumbnail: poster("집이 없어.jpg"),
    externalUrl: "https://laftel.net/item/41593",
  },
  {
    slug: "red-fox",
    title: loc("붉은 여우"),
    description: loc(""),
    thumbnail: poster("붉은여우.jpg"),
    externalUrl: "https://laftel.net/item/42815",
  },
  {
    slug: "dangerous-store",
    title: loc("위험한 편의점"),
    description: loc(""),
    thumbnail: poster("위험한 편의점.jpg"),
    externalUrl: "https://laftel.net/item/42868",
  },
  {
    slug: "pyramid-game",
    title: loc("피라미드 게임"),
    description: loc(""),
    thumbnail: poster("피라미드 게임.jpg"),
    externalUrl: "https://laftel.net/item/42128",
  },
  {
    slug: "independence-diary",
    title: loc("독립일기"),
    description: loc(""),
    thumbnail: poster("독립일기.jpg"),
    externalUrl: "https://laftel.net/item/43522",
  },
  {
    slug: "brave-girl",
    title: loc("용한소녀"),
    description: loc(""),
    thumbnail: poster("용한소녀.jpg"),
    externalUrl: "https://laftel.net/item/43126",
  },
  {
    slug: "hide-the-floor",
    title: loc("마루는 강쥐"),
    description: loc(""),
    thumbnail: poster("마루는 강쥐.jpg"),
    externalUrl: "https://laftel.net/item/43499",
  },
  {
    slug: "close-friends",
    title: loc("친하게 지내자"),
    description: loc(""),
    thumbnail: poster("친하게 지내자.jpg"),
    externalUrl: "https://laftel.net/item/45040",
  },
  {
    slug: "seeingdouble",
    title: {
      ko: "라온의 남자",
      en: "Seeing Double",
      ja: "ラオンの彼",
      "zh-cn": "Seeing Double",
      "zh-tw": "Seeing Double",
    },
    description: {
      ko: "두 남자 사이에서 피어나는 감정",
      en: "Feelings that bloom between two men",
      ja: "二人の男の間で芽生える感情",
      "zh-cn": "在两个男人之间萌生的感情",
      "zh-tw": "在兩個男人之間萌生的感情",
    },
    thumbnail: poster("라온의 남자.png"),
    comingSoon: false,
    notionWorkName: "라온의 남자",
    goodsTitle: {
      ja: "ラオンの彼",
    },
  },
];

export function getOriginalBySlug(slug: string): OriginalMeta | undefined {
  return ORIGINALS_LIST.find((o) => o.slug === slug);
}

if (import.meta.env.DEV) {
  assertOriginalsParity(ORIGINALS_LIST.map((o) => o.slug));
}
